module.exports = __webpack_public_path__ + "img/139.2.79bea3dd.png";